module.exports = __webpack_public_path__ + "img/tick.c95785be.png";